export default __webpack_public_path__ + "src/images/packages/bakubung-villas/dfe5fde54304a3ada9c774caf8e28ac1-1.jpg";